var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 960 960",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 960) scale(1 -1)",
    d: "M423 416L344 496Q331 509 312 509Q293 509 281 496Q268 484 268.5 465Q269 446 281 433L391 323Q405 310 423.5 310Q442 310 455 323L678 546Q690 558 690 577Q690 596 678 608Q665 621 646 621Q627 621 615 608ZM480 72Q395 72 320.5 104Q246 136 191 191Q136 246 104 320.5Q72 395 72 480Q72 565 104 639.5Q136 714 191 769Q246 824 320.5 856Q395 888 480 888Q565 888 639.5 856Q714 824 769 769Q824 714 856 639.5Q888 565 888 480Q888 395 856 320.5Q824 246 769 191Q714 136 639.5 104Q565 72 480 72Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check_circle.96ba1a2fb28fb9920cd64bc139716a6b.svg";
export { ForwardRef as ReactComponent };